/* eslint-disable no-undef */
import "bootstrap";
import "./store-state.js";
import "./response-status.js";
import "./helpers/breadcrumbs-helper.js";
import axios from "axios";

import "../Content/js/vendor/metisMenu.js";
import "../Content/js/vendor/jquery.slimscroll.js";
import "../Content/js/vendor/waves.js";
import "../Content/libs/contextual/contentual.js";
import "../Content/libs/bootstrap-select/bootstrap-select.min.js";
//import "../Content/libs/bootstrap-datepicker/bootstrap-datepicker.min.js";

import "../Content/libs/jquery-steps/jquery.steps.min.js";
//import '../Content/js/pages/form-wizard.init.js';
import "../Content/libs/bootstrap-datepicker/bootstrap-datepicker.min.js";
import "../Content/libs/contextual/contentual.js";
import "../Content/libs/rwd-table/rwd-table.min.js";
import "../Content/libs/imageviewer/imageviewer.min.js";

//js helpers
import "./helpers/side-menu-link-helper.js";
import "./helpers/side-menu-helper.js";
import "./utils/casting-utilities.js";
import "./helpers/currency-helper.js";
import "./helpers/array-helper.js";
import "./helpers/roundingValue-helper.js";
import "./helpers/tooltip-helper.js";
import "./helpers/pageTitle-helper.js";
import "./helpers/contentType-helper.js";
import "./helpers/role-helper.js";
import "./helpers/order-helper.js";
import "./helpers/product-helper.js";
import "./helpers/localStorageCache-helper.js";
import "./helpers/paymentTypes-helper.js";
//import "./helpers/file-helper.js";
//import "./helpers/permissions-helper.js";
import "./helpers/httpResponseCode-helper.js";
import "./helpers/apiResponseHandler-helper.js";
//import "./helpers/siteManagementResponseCodes-helper.js";
import "./helpers/controls/dataTable-helper.js";

import * as echarts from "echarts";
import "../Content/libs/echarts/theme.js";
//services
import "./services/security-service.js";
import './services/system-service.js';
import "./services/heartbeat-service.js";
import "./services/customer-service.js";
import "./services/order-service.js";
import "./services/product-service.js";
import "./services/customerCredits-service.js";
import "./services/settings-service.js";
import "./services/report-service.js";
import "./services/location-service.js";
import "./services/exTank-service.js";

import "../Content/libs/bootstrap-datepicker/bootstrap-datepicker.min.css";
import "../Content/libs/bootstrap-select/bootstrap-select.min.css";
import "../Content/scss/icons.scss";
import "../Content/fonts/Icomoon/style.css";

// permissions helper
import "./helpers/permissions-helper.js";

// import "../Content/fonts/Segeo/segeoFont.css";
import "../Content/fonts/HumanSans/humanSans.css";

import "../Content/scss/app.scss";

import "../Content/style.css";

//import "../Content/scss/_variables.scss";
//import * as echarts from "echarts";
//import "../Content/libs/echarts/theme.js";

import { vMaska } from "maska"
//import maska from "maska";

//vue plugins
import { createRouter, createWebHashHistory } from "vue-router";

window.axios = axios;
window.echarts = echarts;
window.moment = moment;

import TestComponent from "./components/test/test.vue";

//common
import LoadingSpinner from "./components/controls/loadingSpinner/LoadingSpinner.vue";
import DataTable from "./components/controls/dataTable/DataTable.vue";
import DatePicker from "./components/controls/datePicker/DatePicker.vue";
import SuccessModal from "./components/controls/successModal/SuccessModal.vue";
import ErrorModal from "./components/controls/errorModal/ErrorModal.vue";
import BootstrapSelect from "./components/controls/bootstrapSelect/BootstrapSelect.vue";
import ModalForm from "./components/controls/modalForm/ModalForm.vue";
import PasswordGenerator from "./components/controls/passwordGenerator/PasswordGenerator.vue";
import PasswordGeneratorModal from "./components/controls/passwordGeneratorModal/PasswordGeneratorModal.vue";
import ModalMessage from "./components/controls/modalMessage/ModalMessage.vue";
import ActiveInactiveRadioButtons from "./components/controls/activeInactiveRadioButtons/ActiveInactiveRadioButtons.vue";
import FromDateToDatePickers from "./components/controls/fromDateToDatePickers/FromDateToDatePickers.vue";
import MarkAsActiveInactiveModal from "./components/controls/markAsActiveInactiveModal/MarkAsActiveInactiveModal.vue";
import CurrencyInput from "./components/controls/currencyInput/CurrencyInput.vue";
import ManageDepotProductsModal
	from "./components/controls/manageDepotProductsModal/ManageDepotProductsModal.vue";
import Wizard from "./components/controls/wizard/Wizard.vue";
import PasswordUpdateModal from "./components/controls/passwordUpdateModal/PasswordUpdateModal.vue";
import ConfirmDeleteModal from "./components/controls/confirmDeleteModal/ConfirmDeleteModal.vue";

import LogsTable from "./components/Dashboard/controls/logsTable/LogsTable.vue";
import Dashboard from "./components/Dashboard/Dashboard.vue";

//common customer components
import AssignSalesRepToCustomersModal from "./components/customers/common/assignSalesRepToCustomerModal/AssignSalesRepToCustomersModal.vue";
import AssignVehicleToCustomerUserModal from "./components/customers/customerUsers/common/assignVehicleToCustomerUserModal/AssignVehicleToCustomerUserModal.vue";
import CustomerDiscountGroupProductsModal
	from "./components/customers/customerDiscountGroups/common/customerDiscountGroupProducts/CustomerDiscountGroupProductsModal.vue";
import SelectCustomerOrderModal from "./components/customers/common/SelectCustomerOrderModal/SelectCustomerOrderModal.vue";
import CustomerDocumentsModal from "./components/customers/common/CustomerDocumentsModal/CustomerDocumentsModal.vue";

import Customers from "./components/customers/Customers.vue";
import AddEditCustomer from "./components/customers/AddEditCustomer/AddEditCustomer.vue";
import CustomerUsers from "./components/customers/customerUsers/CustomerUsers.vue";
import AddOrEditCustomerUser from "./components/customers/customerUsers/AddOrEditCustomerUser/AddOrEditCustomerUser.vue";
import CustomerAddresses from "./components/customers/customerAddresses/CustomerAddresses.vue";
import TransactionHistory from "./components/customers/transactionHistory/TransactionHistory.vue";
import CustomerDiscountGroups from "./components/customers/customerDiscountGroups/CustomerDiscountGroups.vue";
import CustomerVehicles from "./components/customers/CustomerVehicles/CustomerVehicles.vue";
import PeopleToNotify from "./components/customers/CustomerVehicles/peopleToNotify/PeopleToNotify.vue";

import AssignSalesRepsToCustomerModal
	from "./components/customers/AddEditCustomer/common/AssignSalesRepsToCustomerModal/AssignSalesRepsToCustomerModal.vue";
import BulkCreditTopUpModal from "./components/customers/common/BulkCreditTopUpModal/BulkCreditTopUpModal.vue";
import CompanyAuditModal from "./components/customers/common/companyAuditModal/CompanyAuditModal.vue";
import CompanyOrderAuditsModal from "./components/customers/common/companyOrderAuditsModal/CompanyOrderAuditsModal.vue";

// customer pricing components
import CustomerSpecialPricing from "./components/customers/customerSpecialPricing/CustomerSpecialPricing.vue";
import CustomerGroupPricingForZoneComponent
	from "./components/customers/customerSpecialPricing/delivery/customerGroupPricingForZone/CustomerGroupPricingForZone.vue";
import CustomerDiscountGroupsManagementComponent
	from "./components/customers/customerSpecialPricing/collection/customerDiscountGroupsManagement/CustomerDiscountGroupsManagement.vue";
import CustomerDepotDiscountGroupsManagementComponent
	from "./components/customers/customerSpecialPricing/collection/customerDepotDiscountGroupsManagement/CustomerDepotDiscountGroupsManagement.vue";
import CustomerGroupPricingForZoneExTank
	from "./components/customers/customerSpecialPricing/exTank/CustomerGroupPricingForZoneExTank/CustomerGroupPricingForZoneExTank.vue";

//depot management components
import DepotManagement from "./components/depotManagement/DepotManagement.vue";
import DepotPumpsManagement from "./components/depotManagement/depotPumpsManagement/DepotPumpsManagement.vue";
import DepotSupervisors from "./components/depotManagement/depotSupervisors/DepotSupervisors.vue";
import DepotAttendantManagement from "./components/depotManagement/DepotAttendantManagement/DepotAttendantManagement.vue";

//pricing components
import ProductsManagement from "./components/pricing/productsManagement/ProductsManagement.vue";
import DepotPricingManagement from "./components/pricing/collectionPricing/depotPricingManagement/DepotPricingManagement.vue";
import AddtionalProductsAndServicePricing from "./components/pricing/collectionPricing/addtionalProductsAndServicePricing/AddtionalProductsAndServicePricing.vue";
import CustomerDiscountGroupsManagement
	from "./components/pricing/collectionPricing/customerDiscountGroupsManagement/CustomerDiscountGroupsManagement.vue";
import LinkCustomersToCustomerDiscountGroup
	from "./components/pricing/collectionPricing/customerDiscountGroupsManagement/linkCustomersToCustomerDiscountGroup/LinkCustomersToCustomerDiscountGroup.vue";
import CustomerDepotDiscountGroupsManagement
	from "./components/pricing/collectionPricing/customerDepotDiscountGroupsManagement/CustomerDepotDiscountGroupsManagement.vue";
import LinkCustomersToCustomerDepotDiscountGroup
	from "./components/pricing/collectionPricing/customerDepotDiscountGroupsManagement/linkCustomersToCustomerDepotDiscountGroup/LinkCustomersToCustomerDepotDiscountGroup.vue";
import AddOrEditDiscountGroup
	from "./components/pricing/collectionPricing/customerDiscountGroupsManagement/AddOrEditDiscountGroup/AddOrEditDiscountGroup.vue";
import LinkCustomerToDiscountGroupModal
	from "./components/pricing/collectionPricing/customerDiscountGroupsManagement/common/LinkCustomerToDiscountGroupModal/LinkCustomerToDiscountGroupModal.vue";
import AddOrEditDepotDiscountGroup
	from "./components/pricing/collectionPricing/customerDepotDiscountGroupsManagement/AddOrEditDepotDiscountGroup/AddOrEditDepotDiscountGroup.vue";
import LinkCustomerToDepotDiscountGroupModal
	from "./components/pricing/collectionPricing/customerDepotDiscountGroupsManagement/common/LinkCustomerToDepotDiscountGroupModal/LinkCustomerToDepotDiscountGroupModal.vue";
import ComboDiscountGroupsManagement
	from "./components/pricing/collectionPricing/comboDiscountGroupsManagement/ComboDiscountGroupsManagement.vue";
import AddOrEditComboDiscountGroup
	from "./components/pricing/collectionPricing/comboDiscountGroupsManagement/AddOrEditComboDiscountGroup/AddOrEditComboDiscountGroup.vue";
import LinkProductsToComboDiscountGroupModal
	from "./components/pricing/collectionPricing/comboDiscountGroupsManagement/common/linkProductsToComboDiscountGroupModal/LinkProductsToComboDiscountGroupModal.vue";

// delivery pricing
import ProductBasePricingDelivery
	from "./components/pricing/deliveryPricing/productBasePricingDelivery/ProductBasePricingDelivery.vue";
import AddOrProductBasePricingDelivery
	from "./components/pricing/deliveryPricing/addOrEditProductBasePricingDelivery/AddOrProductBasePricingDelivery.vue";
import DeliveryPricingBulkImport
	from "./components/pricing/deliveryPricing/deliveryPricingBulkImport/DeliveryPricingBulkImport.vue";
import CustomerGroupPricingForZone
	from "./components/pricing/deliveryPricing/customerGroupPricingForZone/CustomerGroupPricingForZone.vue";
import AddOrUpdateCustomerGroupPricingForZone
	from "./components/pricing/deliveryPricing/customerGroupPricingForZone/addOrUpdateCustomerGroupPricingForZone/AddOrUpdateCustomerGroupPricingForZone.vue";


//delivery pricing common
import ZoneProductPricingAddOrUpdateTable
	from "./components/pricing/deliveryPricing/common/zoneProductPricingAddOrUpdateTable/ZoneProductPricingAddOrUpdateTable.vue";
import DeliveryPricingBulkImportValidation
	from "./components/pricing/deliveryPricing/common/deliveryPricingBulkImportValidation/DeliveryPricingBulkImportValidation.vue";
import ZonePricingForCustomerAddOrUpdateTable
	from "./components/pricing/deliveryPricing/common/zonePricingForCustomerAddOrUpdateTable/ZonePricingForCustomerAddOrUpdateTable.vue";

//logistics management components
import DriverManagement from "./components/logistics/driverManagement/DriverManagement.vue";
import VehicleManagement from "./components/logistics/vehicleManagement/VehicleManagement.vue";

import VehicleCompartmentsTable
	from "./components/logistics/vehicleManagement/common/vehicleCompartmentsTable/VehicleCompartmentsTable.vue";

// system management components
import ReasonsForDeliveryFailureManagement
	from "./components/systemManagement/reasonsForDeliveryFailureManagement/ReasonsForDeliveryFailureManagement.vue";
import AreasManagement from "./components/systemManagement/areasManagement/AreasManagement.vue";
import ZonesManagement from "./components/systemManagement/zonesManagement/ZonesManagement.vue";
import CollectionOrdersValidationConfigurations
	from "./components/systemManagement/CollectionOrdersValidationConfigurations/CollectionOrdersValidationConfigurations.vue";

// order management components
import DeliveryOrderManagement from "./components/orderManagement/deliveryOrderManagement/DeliveryOrderManagement.vue";
import CollectionOrderManagement
	from "./components/orderManagement/collectionOrderManagement/CollectionOrderManagement.vue";
//import OrderManagement from "./components/orderManagement/OrderManagement.vue";
import ViewOrder from "./components/orderManagement/viewOrder/ViewOrder.vue";
import ReviewOrder from "./components/orderManagement/reviewOrder/ReviewOrder.vue";
import ScheduleOrderForDelivery from "./components/orderManagement/scheduleOrderForDelivery/ScheduleOrderForDelivery.vue";
import ViewOrderSchedule from "./components/orderManagement/viewOrderSchedule/ViewOrderSchedule.vue";
import ReasonForDeliveryCancellation
	from "./components/orderManagement/reasonForDeliveryCancellation/ReasonForDeliveryCancellation.vue";
import ViewOrderCollection from "./components/orderManagement/viewOrderCollection/ViewOrderCollection.vue";
import OrderEnquiryMessages from "./components/orderManagement/OrderEnquiryMessages/OrderEnquiryMessages.vue";

import SelectDeliveryOrdersForScheduling
	from "./components/orderManagement/deliveryOrderManagement/SelectDeliveryOrdersForScheduling/SelectDeliveryOrdersForScheduling.vue";
import SequenceDeliveryOrdersForDelivery
	from "./components/orderManagement/deliveryOrderManagement/SequenceDeliveryOrdersForDelivery/SequenceDeliveryOrdersForDelivery.vue";
import ScheduleDeliveryOrdersForDelivery
	from "./components/orderManagement/deliveryOrderManagement/ScheduleDeliveryOrdersForDelivery/ScheduleDeliveryOrdersForDelivery.vue";
import ResequenceDeliveryOrdersForDelivery
	from "./components/orderManagement/deliveryOrderManagement/ResequenceDeliveryOrdersForDelivery/ResequenceDeliveryOrdersForDelivery.vue";

import OrderItemsCompartmentAssigningTable
	from "./components/orderManagement/deliveryOrderManagement/common/OrderItemsCompartmentAssigningTable/OrderItemsCompartmentAssigningTable.vue";
import SelectVehicleCompartmentsForOrderModal
	from "./components/orderManagement/deliveryOrderManagement/common/SelectVehicleCompartmentsForOrderModal/SelectVehicleCompartmentsForOrderModal.vue";

//order management common components
import CustomerSelectForOrder from "./components/orderManagement/common/customerSelectForOrder/CustomerSelectForOrder.vue";
import ProductSelectForOrder from "./components/orderManagement/common/productSelectModal/ProductSelectForOrder.vue";
import ProductSelectCollectionOrder
	from "./components/orderManagement/common/collection/productSelectCollectionOrder/ProductSelectCollectionOrder.vue";
import SelectOrderTypeModal from "./components/orderManagement/common/selectOrderTypeModal/SelectOrderTypeModal.vue";
import ShippingAddressForOrder
	from "./components/orderManagement/common/shippingAddressSelectForOrder/ShippingAddressForOrder.vue";
import CreateDeliveryOrderModal
	from "./components/orderManagement/common/createDeliveryOrderModal/CreateDeliveryOrderModal.vue";
import ReasonForOrderRejectionModal
	from "./components/orderManagement/common/reasonForOrderRejectionModal/ReasonForOrderRejectionModal.vue";
import TrackingHistoryModal from "./components/orderManagement/common/trackingHistoryModal/TrackingHistoryModal.vue";
import OrderAuditModal from "./components/orderManagement/common/orderAuditModal/OrderAuditModal.vue";
import SelectShippingAddressForOrderModal
	from "./components/orderManagement/common/selectShippingAddressForOrderModal/SelectShippingAddressForOrderModal.vue";
import OrderItemsTable from "./components/orderManagement/common/orderItemsTable/OrderItemsTable.vue";
import DispenseOrderItemForOrderTable from "./components/orderManagement/common/dispenseOrderItemForOrderTable/DispenseOrderItemForOrderTable.vue";
import CreateCollectionOrderModal
	from "./components/orderManagement/common/createCollectionOrderModal/CreateCollectionOrderModal.vue";
import OrderDocumentsModal from "./components/orderManagement/common/OrderDocumentsModal/OrderDocumentsModal.vue";

// ex-tank orders
import ExTankOrderManagement from "./components/orderManagement/ExTankOrderManagement/ExTankOrderManagement.vue";
import AddOrUpdateExTankOrderModal
	from "./components/orderManagement/ExTankOrderManagement/common/AddOrUpdateExTankOrderModal/AddOrUpdateExTankOrderModal.vue";
import ViewExTankOrder from "./components/orderManagement/ExTankOrderManagement/ViewExTankOrder/ViewExTankOrder.vue";
import ReviewOrderExTank from "./components/orderManagement/ExTankOrderManagement/ReviewOrderExTank/ReviewOrderExTank.vue";
import CompleteExTankOrder
	from "./components/orderManagement/ExTankOrderManagement/CompleteExTankOrder/CompleteExTankOrder.vue";

import ProductSelectForExTankOrder
	from "./components/orderManagement/ExTankOrderManagement/common/ProductSelectForExTankOrder/ProductSelectForExTankOrder.vue";

// ex-tank pricing
import ProductBasePriceExTank from "./components/pricing/exTankPricing/ProductBasePriceExTank/ProductBasePriceExTank.vue";
import AddOrUpdateProductBasePriceExTank
	from "./components/pricing/exTankPricing/ProductBasePriceExTank/AddOrUpdateProductBasePriceExTank/AddOrUpdateProductBasePriceExTank.vue";
import ExTankBulkImport
	from "./components/pricing/exTankPricing/ProductBasePriceExTank/ExTankBulkImport/ExTankBulkImport.vue";

import CustomerPricingPerZone from "./components/pricing/exTankPricing/CustomerPricingPerZone/CustomerPricingPerZone.vue";
import AddOrUpdateCustomerGroupPricingForZoneExTank
	from "./components/pricing/exTankPricing/CustomerPricingPerZone/AddOrUpdateCustomerGroupPricingForZoneExTank/AddOrUpdateCustomerGroupPricingForZoneExTank.vue";

import LinkAndUnlinkCompanyFromDepotDiscountGroupsModal
	from "./components/customers/customerSpecialPricing/collection/customerDepotDiscountGroupsManagement/linkAndUnlinkCompayFromDepotDiscountGroupsModal/LinkAndUnlinkCompayFromDepotDiscountGroupsModal.vue";
import LinkAndUnlinkCompanyDiscountGroupsModal
	from "./components/customers/customerSpecialPricing/collection/customerDiscountGroupsManagement/linkAndUnlinkCompanyDiscountGroupModal/LinkAndUnlinkCompanyDiscountGroupsModal.vue";


//OTA module
import FuelDispensementCapture from "./components/otaModule/fuelDispensementCapture/FuelDispensementCapture.vue";
// common components
import FuelDispensementValidation
	from "./components/otaModule/common/fuelDispensementValidationForm/FuelDispensementValidation.vue";
import DispenseFuelForm from "./components/otaModule/common/dispenseFuelForm/DispenseFuelForm.vue";

//common driver management components
import DriverVehicleModal from "./components/logistics/driverManagement/common/driverVehicleModal/DriverVehicleModal.vue";

//user management common components
import SalesRepCustomerModal from "./components/userManagement/common/salesRepCustomersModal/SalesRepCustomerModal.vue";
import LinkCustomerShippingAddressesToSalesRepModal
	from "./components/userManagement/common/LinkCustomerShippingAddressesToSalesRepModal/LinkCustomerShippingAddressesToSalesRepModal.vue";

import UserManagement from "./components/userManagement/UserManagement.vue";

//accounts management
import AccountsManagement from "./components/AccountsManagement/AccountsManagement.vue";
import SuspendedCustomers from "./components/AccountsManagement/SuspendedCustomers/SuspendedCustomers.vue";


import { createApp } from "vue";

//common pricing components
import LinkProductsToCustomerDiscountGroupModal
	from "./components/pricing/collectionPricing/customerDiscountGroupsManagement/common/linkProductsToCustomerDiscountGroupModal/LinkProductsToCustomerDiscountGroupModal.vue";
import LinkProductsToCustomerDepotDiscountGroupModal
	from "./components/pricing/collectionPricing/customerDepotDiscountGroupsManagement/common/linkProductsToCustomerDepotDiscountGroupModal/LinkProductsToCustomerDepotDiscountGroupModal.vue";

let options = {
	data() {
		return {
			sharedState: storeState.state,
			breadcrumbs: [],
			maxBreadcrumbs: 3,
			breadcrumbsSessionKey: "breadcrumbs",
			isRefreshed: true,
			breadcrumbState: breadcrumbsStoreState.breadcrumbsState,
			//hideTitleBar: false,
			welcomePageReplacedInNavigationHistory: false,
			shouldReplaceUrl: true
		};
	},
	methods: {
		navigateToNewRoot(route){
			if(!this.welcomePageReplacedInNavigationHistory){
				this.$router.replace(route);
				this.welcomePageReplacedInNavigationHistory = true;
			}
			else{
				this.$router.push(route);
			}
		},
		determineIfMenuItemsShouldReplaceUrl(){
			if(window.location.hash === "#/"){
				this.shouldReplaceUrl = true;
			}
			else{
				this.shouldReplaceUrl = false;
			}
		}
	},
	components: {
	},
	mounted: function () {
		//this.loadBreadcrumbs();
		permissionsHelper.getPermissions(false, false);
		let hasLoggedIn = false;
		let hasLoggedSession = sessionStorage.getItem("hasLoggedInSession");
		if(hasLoggedSession !== null){
			hasLoggedIn = castingUtility.toBoolean(hasLoggedSession);
		}
		else{
			sessionStorage.setItem("hasLoggedInSession", "true");
		}
		if(!hasLoggedIn){
			// permissionsHelper.getPermissions(false, false);
			let menuItems = document.getElementById("side-menu").querySelectorAll("li > a");
			for(let i = 0; i < menuItems.length; i++){
				if(!menuItems[i].classList.contains("menuItemLink")){
					let newHomeRoute = menuItems[i].hash.replace("#", "");
					this.$router.replace(newHomeRoute);
					break;
				}
			}
		}
		breadcrumbsStoreState.loadBreadcrumbs();
		setTimeout(function (){
			sideMenuLinksHelper.updateActiveLinks();
		}, 100);
	},
	watch: {
		'$route':{
		    handler: function(){
		        console.log("route app js", this.$route);
				permissionsHelper.setCurrentRoute(this.$route);
		    },
		    immediate: true,
		    deep: true
		},
		breadcrumbState:{
			handler: function(){
				this.breadcrumbs = breadcrumbsStoreState.getBreadcrumbsToDisplay();
			},
			immediate: true,
			deep: true
		}
	}
};

const app = createApp(options).directive("maska", vMaska);

app.component("test", TestComponent);
app.component("loading-spinner", LoadingSpinner);
app.component("logs-table", LogsTable);
app.component("data-table", DataTable);
app.component("date-picker", DatePicker);
app.component("success-modal", SuccessModal);
app.component("error-modal", ErrorModal);
app.component("bootstrap-select", BootstrapSelect);
app.component("modal-form", ModalForm);
app.component("modal-message", ModalMessage);
app.component("password-generator-modal", PasswordGeneratorModal);
app.component("password-generator", PasswordGenerator);
app.component("active-inactive-radio-buttons", ActiveInactiveRadioButtons);
app.component("from-date-to-date-pickers", FromDateToDatePickers);
app.component("mark-as-active-inactive-modal", MarkAsActiveInactiveModal);
app.component("currency-input", CurrencyInput);
app.component("wizard", Wizard);
app.component("password-update-modal", PasswordUpdateModal);
app.component("confirm-delete-modal", ConfirmDeleteModal);

//user management common components
app.component("sales-rep-customer-modal", SalesRepCustomerModal);
app.component("link-customer-shipping-addresses-to-sales-rep-modal", LinkCustomerShippingAddressesToSalesRepModal);

//customer common components
app.component("assign-sales-rep-to-customers-modal", AssignSalesRepToCustomersModal);
app.component("assign-vehicle-to-customer-user-modal", AssignVehicleToCustomerUserModal);
app.component("customer-discount-group-products-modal", CustomerDiscountGroupProductsModal);
app.component("customer-group-pricing-for-zone-component", CustomerGroupPricingForZoneComponent);
app.component("customer-group-pricing-for-zone-ex-tank", CustomerGroupPricingForZoneExTank);
app.component("customer-discount-groups-management-component", CustomerDiscountGroupsManagementComponent);
app.component("customer-depot-discount-groups-management-component", CustomerDepotDiscountGroupsManagementComponent);
app.component("assign-salesReps-to-customer-modal", AssignSalesRepsToCustomerModal);
app.component("select-customer-order-modal", SelectCustomerOrderModal);
app.component("customer-documents-modal", CustomerDocumentsModal);
app.component("bulk-credit-top-up-modal", BulkCreditTopUpModal);
app.component("company-audit-modal", CompanyAuditModal);
app.component("company-order-audits-modal", CompanyOrderAuditsModal);

//common driver management components
app.component("driver-vehicle-modal", DriverVehicleModal);

// common logistics vehicle management components
app.component("vehicle-compartments-table", VehicleCompartmentsTable);

//common depot management components
app.component("manage-depot-products-modal", ManageDepotProductsModal);

//common pricing components
app.component("link-products-to-customer-discount-group-modal", LinkProductsToCustomerDiscountGroupModal);
app.component("link-products-to-customer-depot-discount-group-modal", LinkProductsToCustomerDepotDiscountGroupModal);
app.component("link-customer-to-discount-group-modal", LinkCustomerToDiscountGroupModal);
app.component("link-customer-to-depot-discount-group-modal", LinkCustomerToDepotDiscountGroupModal);

//common delivery pricing
app.component("zone-product-pricing-add-update-table", ZoneProductPricingAddOrUpdateTable);
app.component("delivery-pricing-bulk-import-validation", DeliveryPricingBulkImportValidation);
app.component("zone-pricing-for-customer-add-update-table", ZonePricingForCustomerAddOrUpdateTable);

//order common components
app.component("product-select-for-order", ProductSelectForOrder);
app.component("product-select-collection-order", ProductSelectCollectionOrder);
app.component("customer-select-for-order", CustomerSelectForOrder);
app.component("select-order-type-modal", SelectOrderTypeModal);
app.component("shipping-address-for-order", ShippingAddressForOrder);
app.component("create-delivery-order-modal", CreateDeliveryOrderModal);
app.component("create-collection-order-modal", CreateCollectionOrderModal);
app.component("reason-for-order-rejection-modal", ReasonForOrderRejectionModal);
app.component("tracking-history-modal", TrackingHistoryModal);
app.component("order-audit-modal", OrderAuditModal);
app.component("select-shipping-address-for-order-modal", SelectShippingAddressForOrderModal);
app.component("order-items-table", OrderItemsTable);
app.component("dispense-order-item-for-order-table", DispenseOrderItemForOrderTable);
app.component("link-unlink-customers-to-depot-discount-group", LinkAndUnlinkCompanyFromDepotDiscountGroupsModal);
app.component("link-unlink-customers-to-discount-group", LinkAndUnlinkCompanyDiscountGroupsModal);
app.component("link-products-to-combo-discount-group-modal", LinkProductsToComboDiscountGroupModal);
app.component("order-documents-modal", OrderDocumentsModal);

app.component("product-select-for-exTank-order", ProductSelectForExTankOrder);
app.component("add-or-update-exTank-order-modal", AddOrUpdateExTankOrderModal);

app.component("order-items-compartment-assigning-table", OrderItemsCompartmentAssigningTable);
app.component("select-vehicle-compartments-for-order-modal", SelectVehicleCompartmentsForOrderModal);

//common OTA Module
app.component("fuel-dispensement-validation", FuelDispensementValidation);
app.component("dispense-fuel-form", DispenseFuelForm);

//app.use(vMaska);

//global filters
app.config.globalProperties.$filters = {
	dateShortForm(date, showTime) {
		if(showTime){
			// eslint-disable-next-line no-undef
			return moment(date).format("DD MMM YYYY HH:mm");
		}
		// eslint-disable-next-line no-undef
		return moment(date).format("DD MMM YYYY");
	}
};

if (document.getElementById("spa-page")){
	const routes = [
		{ 
			path: "/", 
			component: Dashboard
		},
		{ 
			path: "/customers", 
			component: Customers
		},
		{
			path: "/accounts",
			component: AccountsManagement
		},
		{
			path: "/accounts/suspended",
			component: SuspendedCustomers
		},
		{ 
			path: "/customers/addEditCustomer/:companyId?", 
			component: AddEditCustomer,
			props: true
		},
		{
			path: "/customers/customerUsers/:companyId?", 
			component: CustomerUsers,
			props: true
		},
		{
			path: "/customers/customerUsers/addCustomerUser/:companyId?", 
			component: AddOrEditCustomerUser,
			props: true
		},
		{
			path: "/customers/customerUsers/editCustomerUser/:userId?/:companyId?", 
			component: AddOrEditCustomerUser,
			props: true
		},
		{
			path: "/customers/customerAddresses/:companyId?", 
			component: CustomerAddresses,
			props: true
		},
		{
			path: "/customers/transactionHistory/:companyId?", 
			component: TransactionHistory,
			props: true
		},
		{
			path: "/customers/customerDiscountGroups/:companyId?",
			component: CustomerDiscountGroups,
			props: true
		},
		{
			path: "/customers/customerVehicles/:companyId?",
			component: CustomerVehicles,
			props: true
		},
		{
			path: "/customers/customerVehicles/peopleToNotify/:vehicleId?/:companyId?",
			component: PeopleToNotify,
			props: true
		},
		{
			path: "/customers/customerSpecialPricing/:companyId?",
			component: CustomerSpecialPricing,
			props: true
		},
		// {
		// 	path: "/orders/:companyId?",
		// 	component: OrderManagement,
		// 	props: true
		// },
		{
			path: "/orders/delivery/:companyId?",
			component: DeliveryOrderManagement,
			props: true
		},
		{
			path: "/orders/delivery/selectDeliveryOrdersForScheduling",
			component: SelectDeliveryOrdersForScheduling
		},
		{
			path: "/orders/delivery/sequenceDeliveryOrdersForDelivery",
			component: SequenceDeliveryOrdersForDelivery
		},
		{
			path: "/orders/delivery/scheduleDeliveryOrdersForDelivery/:orderDeliveryScheduleId?",
			component: ScheduleDeliveryOrdersForDelivery,
			props: true
		},
		{
			path: "/orders/delivery/resequenceDeliveryOrdersForDelivery",
			component: ResequenceDeliveryOrdersForDelivery
		},
		{
			path: "/orders/collection/:companyId?",
			component: CollectionOrderManagement,
			props: true
		},
		{
			path: "/orders/viewOrder/:orderId?/:orderDeliveryId?/:orderDeliveryScheduleId?",
			component: ViewOrder,
			props: true
		},
		{
			path: "/orders/viewCollectionOrder/:orderId?/:orderCollectionId?",
			component: ViewOrderCollection,
			props: true
		},
		{
			path: "/orders/reviewOrder/:orderId?/:orderDeliveryId?",
			component: ReviewOrder,
			props: true
		},
		{
			path: "/orders/viewOrderSchedule/:orderId?/:orderDeliveryId?/:orderDeliveryScheduleId?",
			component: ViewOrderSchedule,
			props: true
		},
		{
			path: "/orders/scheduleOrderForDelivery/:orderId?/:orderDeliveryId?/:orderDeliveryScheduleId?",
			component: ScheduleOrderForDelivery,
			props: true
		},
		{
			path: "/orders/reasonForDeliveryCancellation/:orderId?/:orderDeliveryId?/:orderDeliveryScheduleId?",
			component: ReasonForDeliveryCancellation,
			props: true
		},
		{
			path: "/orders/extank/:companyId?",
			component: ExTankOrderManagement,
			props: true
		},
		{
			path: "/orders/extank/viewOrder/:orderExTankId?/:orderId?",
			component: ViewExTankOrder,
			props: true
		},
		{
			path: "/orders/extank/reviewOrder/:orderExTankId?/:orderId?",
			component: ReviewOrderExTank,
			props: true
		},
		{
			path: "/orders/extank/completeOrder/:orderExTankId?/:orderId?",
			component: CompleteExTankOrder,
			props: true
		},
		{
			path: "/orders/orderEnquiryMessages/:orderId?/:companyId?/:orderTypeId?/:orderStatusId?",
			component: OrderEnquiryMessages,
			props: true
		},
		{
			path: "/productsManagement",
			component: ProductsManagement
		},
		{
			path: "/pricing/delivery/productBasePricing",
			component: ProductBasePricingDelivery
		},
		{
			path: "/pricing/delivery/addDeliveryBasePrice",
			component: AddOrProductBasePricingDelivery
		},
		{
			path: "/pricing/delivery/editDeliveryBasePrice/:productId?",
			component: AddOrProductBasePricingDelivery,
			props: true
		},
		{
			path: "/pricing/delivery/bulkImport",
			component: DeliveryPricingBulkImport
		},
		{
			path: "/pricing/delivery/customerGroupPricingForZone",
			component: CustomerGroupPricingForZone
		},
		{
			path: "/pricing/delivery/addCustomerGroupPricingForZone/:companyId?",
			component: AddOrUpdateCustomerGroupPricingForZone,
			props: true
		},
		{
			path: "/pricing/delivery/editCustomerGroupPricingForZone/:productId?/:companyId?",
			component: AddOrUpdateCustomerGroupPricingForZone,
			props: true
		},
		{
			path: "/pricing/collection/depotPricingManagement",
			component: DepotPricingManagement
		},
		{
			path: "/pricing/collection/additionalProductsAndServicePricing",
			component: AddtionalProductsAndServicePricing
		},
		{
			path: "/pricing/collection/customerDiscountGroupsManagement",
			component: CustomerDiscountGroupsManagement
		},
		{
			path: "/pricing/collection/customerDiscountGroups/addOrEditDiscountGroup/:customerDiscountGroupId?",
			component: AddOrEditDiscountGroup,
			props: true
		},
		{
			path: "/pricing/collection/customerDiscountGroups/linkProductsToCustomerDiscountGroup/:customerDiscountGroupId?",
			component: LinkCustomersToCustomerDiscountGroup,
			props: true
		},
		{
			path: "/pricing/collection/customerDepotDiscountGroupsManagement",
			component: CustomerDepotDiscountGroupsManagement
		},
		{
			path: "/pricing/collection/customerDepotDiscountGroups/addOrEditDepotDiscountGroup/:customerDepotDiscountGroupId?",
			component: AddOrEditDepotDiscountGroup,
			props: true
		},
		{
			path: "/pricing/collection/customerDepotDiscountGroups/linkProductsToCustomerDepotDiscountGroup/:customerDiscountGroupId?",
			component: LinkCustomersToCustomerDepotDiscountGroup,
			props: true
		},
		{
			path: "/pricing/combo-discount-groups",
			component: ComboDiscountGroupsManagement
		},
		{
			path: "/pricing/combo-discount-groups/add",
			component: AddOrEditComboDiscountGroup
		},
		{
			path: "/pricing/combo-discount-groups/edit/:comboDiscountGroupId?",
			component: AddOrEditComboDiscountGroup,
			props: true
		},
		{
			path: "/pricing/extank/productBasePricing",
			component: ProductBasePriceExTank
		},
		{
			path: "/pricing/extank/addExTankBasePrice",
			component: AddOrUpdateProductBasePriceExTank
		},
		{
			path: "/pricing/extank/editExTankBasePrice/:productId?",
			component: AddOrUpdateProductBasePriceExTank,
			props: true
		},
		{
			path: "/pricing/extank/bulkImport",
			component: ExTankBulkImport
		},
		{
			path: "/pricing/extank/customerPricingPerZone",
			component: CustomerPricingPerZone
		},
		{
			path: "/pricing/extank/addCustomerGroupPricingForZone/:companyId?",
			component: AddOrUpdateCustomerGroupPricingForZoneExTank,
			props: true
		},
		{
			path: "/pricing/extank/editCustomerGroupPricingForZone/:productId?/:companyId?",
			component: AddOrUpdateCustomerGroupPricingForZoneExTank,
			props: true
		},
		{
			path: "/depots",
			component: DepotManagement
		},
		{
			path: "/depots/depotPumpsManagement/:depotId?/:depotName?",
			component: DepotPumpsManagement,
			props: true
		},
		{
			path: "/depots/depotSupervisors/:depotId?/:depotName?",
			component: DepotSupervisors,
			props: true
		},
        {
            path: "/depots/depotAttendants/:depotId?/:depotName?",
            component: DepotAttendantManagement,
            props: true
        },
		{
			path: "/userManagement", 
			component: UserManagement
		},
		{
			path: "/fuelDispensementCapture/:collectionCode?/:vehicleId?",
			component: FuelDispensementCapture,
			props: true
		},
		{
			path: "/logistics/driverManagement",
			component: DriverManagement
		},
		{
			path: "/logistics/vehicleManagement",
			component: VehicleManagement
		},
		{
			path: "/system/reasonsForDeliveryFailureManagement",
			component: ReasonsForDeliveryFailureManagement
		},
		{
			path: "/system/areasManagement",
			component: AreasManagement
		},
		{
			path: "/system/zonesManagement",
			component: ZonesManagement
		},
		{
			path: "/system/collectionOrdersValidationConfigurations",
			component: CollectionOrdersValidationConfigurations
		}
	];

	const router = createRouter({
		history: createWebHashHistory(),
		//history: createWebHistory('Portal/Home'),
		routes, // short for `routes: routes`
	});
	app.use(router);
}

if (document.getElementById("app")) {
	//load vue js options on specific pages
	app.mount("#app");
}

